import AOS from 'aos';
import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import router from './routes';

const App: React.FC = () => {
  useEffect(() => {
    const doc = document.documentElement;

    const setHeight = () => {
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };

    window.addEventListener('resize', setHeight);
    setHeight();

    AOS.init({
      duration: 700,
      easing: 'ease-out-cubic',
      offset: 150,
    });

    return () => {
      window.removeEventListener('resize', setHeight);
    };
  }, []);

  return <RouterProvider router={router} />;
};

export default App;
